// 请求拦截和响应拦截

import axios from 'axios'
import router from '../router'
import {
    Message,
    MessageBox
} from 'element-ui'
import {
    getCookie,
    removeSave,
} from '@/utils/auth'

window.requestUrl = process.env.BASE_API
const service = axios.create({
    baseURL: window.requestUrl,
    timeout: 60000,
    headers: {
        post: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
})

// request请求拦截器
service.interceptors.request.use(config => {
    if (getCookie('Session-Id')) {
        config.headers['sessionid'] = getCookie('Session-Id') // 让每个请求携带自定义的值
        console.log(getCookie('Session-Id'));
    }
    return config
}, error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error)
})

// respone响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        switch (res.code) {
            case '000000':
                /*响应成功*/
                return res;
            case '777777':
                return res;
                // 未登录
            case 'PW00001':
                removeSave();
                window.location.href = window.location.origin + '/home'
                    // router.replace({
                    //   name: 'home',
                    // })
                    // Message({
                    //   message: res.message,
                    //   type: 'error',
                    //   duration: 1 * 1000
                    // });
                break;

            case 'PW00002':
                window.location.href = window.location.origin + '/home'
                break;
                // 异地登录
            case 'PW00003':
                removeSave();
                window.location.href = window.location.origin + '/home'
                    // Message({
                    //   message: res.message,
                    //   type: 'error',
                    //   duration: 3 * 1000
                    // });
                break;

            case '666666':
                Message({
                    message: res.message,
                    type: 'warning',
                    duration: 3 * 1000
                });
                break;

            case '555555': //数据变更  退回前一页
                Message({
                    message: res.message,
                    type: 'warning',
                    duration: 3 * 1000
                });
                router.go(-1);
                break;

            default:
                Message({
                    message: res.message,
                    type: 'error',
                    duration: 2 * 1000
                });
                break;
        }
        return Promise.reject(new Error('error'))
    },
    (err) => { // 这里是返回状态码不为200时候的错误处理
        if (err && err.response) {
            switch (err.response.status) {
                case 400:
                    err.message = '请求错误';
                    break;

                case 401:
                    err.message = '未授权，请登录';
                    break;

                case 403:
                    err.message = '拒绝访问';
                    break;

                case 404:
                    router.replace({
                        path: '*',
                    })
                    break;

                case 408:
                    err.message = '请求超时';
                    break;

                case 500:
                    err.message = '服务器内部错误';

                    break;

                case 501:
                    err.message = '服务未实现';
                    break;

                case 502:
                    err.message = '网关错误';
                    break;

                case 503:
                    err.message = '服务不可用';
                    break;

                case 504:
                    err.message = '网关超时';
                    break;

                case 505:
                    err.message = 'HTTP版本不受支持';
                    break;

                default:
                    err.message = '网络错误';
                    break;
            }
        } else {
            err.message = "网络出现问题，请稍后再试"
        }
        Message({
            message: err.message,
            type: 'error',
            duration: 2 * 1000
        });
        return Promise.reject(err)
    }
);
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js